import React, { useState, useEffect, useContext } from 'react';
import { Form, Radio, Button } from 'antd';
import Typing from '../Typing/Typing';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp'
import * as Api from '../../services/api';
import { Context } from '../../ChatContext';
import * as dayjs from 'dayjs';
import * as isTomorrow from 'dayjs/plugin/isTomorrow';
import * as updateLocale from 'dayjs/plugin/updateLocale';
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import CmpsNotValid from '../CmpsNotValid/CmpsNotValid';
import * as Utils from '../../services/utils';

function CmpsDate({onComplete, onScroll, form, coords, onError, onShowInput, onReset}) {
  const [typing, setTyping] = useState(true);
  const [listDays, setListDays] = useState(false);
  const [msg, setMsg] = useState(false);
  const [context, setContext] = useContext(Context);
  const [itemsToShow, setItemsToShow] = useState(3);
  
  const onChange = (e) => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/data-appuntamento');
    setMsg(form.getFieldValue("data").label);
    onComplete('step3');
  }

  const showMoreLess = () => {
    if (itemsToShow + 3 <= listDays.length) {
      setItemsToShow(itemsToShow + 3);
    } else {
      setItemsToShow(3);
    }
    setTimeout(() => {
      onScroll();
    });
  }

  const reset = () => {
    onReset();
  }


  useEffect(() => {
    onShowInput(false);
    dayjs.extend(isTomorrow);
    dayjs.extend(updateLocale);
    dayjs.updateLocale('en', {
      weekdays: [
        "Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"
      ],
      months: [
        "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio",
        "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
      ]
    })
   
    const params = {
      Coordinate: {
        lat: context.coordinates.lat,
        lng: context.coordinates.lon
      },
      RecPerPage: 12      
    }
    Api.getGiorniDisponibili(params).then(function (response) {
      const list = response.data.map((day) => {
        return {
          label: dayjs(day).isTomorrow() ? 'Domani' : dayjs(day).format("dddd D MMMM"),
          value: day,
          easyDate: dayjs(day).format("YYYY-MM-DD")
        }
      });
  
      setListDays(list);

      if(response.timings && response.timings.elapsedTime) {
        if(response.timings.elapsedTime <= 2000) {
          setTimeout(() => {
            setTyping(false);
            onScroll();
          }, 2000);
        } else {
          setTyping(false);
          onScroll();
        }
      } else {
        setTyping(false);
        onScroll();
      }
      
    })
    .catch(function (error) {
      console.log(error);
      onError();
    });

  }, []);


  return (
    <section id="date">
      {typing && <Typing wait={1000} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300} last={listDays.length > 0 ? true : false}>
              <span className="bubble">Quando vuoi fissare<br /> l’appuntamento?</span>
            </CmpsAnimation>
            {listDays.length <= 0 && (
              <>
                <CmpsNotValid msg="Non c'è possibilità di fissare un appuntamento nelle tue vicinanze. Ti consigliamo di procedere con una nuova richiesta provando una combinazione differente." />
                <CmpsAnimation wait={2200}>
                  <Button className={['cmps_btn', 'cmps_btn__redirect']} onClick={reset}>RICOMINCIA!</Button>
                </CmpsAnimation>
              </>
            )}
            {(!msg && listDays.length > 0) && (
              <CmpsAnimation wait={600}>
                <Form.Item className={`cmps_radio_button`} name="data">
                  <Radio.Group onChange={onChange}>
                    {listDays.slice(0, itemsToShow).map((item, index) =>
                      <Radio.Button key={index} value={item}>{item.label}</Radio.Button>
                    )}
                  </Radio.Group>
                </Form.Item>
                <p className={`show_more`} onClick={showMoreLess}>
                  {itemsToShow===12 ? 'Mostra meno giorni' : 'Mostra giorni successivi'}
                </p>
                <div className="info">
                  <span className="time"><Timestamp /></span>
                </div>
              </CmpsAnimation>
            )}
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={300}>
            <div className="message">
              <span className="bubble">{msg}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
    </section>
  );
} 

export default CmpsDate;
